import { DO_CLICK_ACTIONS, DO_IMPRESSION_ACTIONS, LABELS, SCREEN_NAME, SOURCE } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const clickCloseDineoutPaymentSuccess = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    isClose: boolean,
    orderId: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action: isClose ? DO_CLICK_ACTIONS.CLOSE : DO_CLICK_ACTIONS.DONE,
        value: isClose ? LABELS.CLOSE_CLICK : LABELS.DONE_CLICK,
        context: JSON.stringify({
            bookingId: orderId,
            source: SOURCE,
        }),
    });
};

export const clickViewHelpDineoutPaymentSuccess = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    orderId: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action: DO_CLICK_ACTIONS.HELP,
        label: LABELS.HELP_CLICK,
        value: orderId,
        context: JSON.stringify({
            source: SOURCE,
        }),
    });
};

export const impressionDineoutPaymentSuccess = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { orderId, dealCategory }: { orderId: string; dealCategory: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS, // category refers to screen name
        action: DO_IMPRESSION_ACTIONS.PAYMENT_SUCCESS, //action refers to object name
        context: JSON.stringify({
            bookingId: orderId,
            source: SOURCE,
            dealCategory: dealCategory,
        }),
    });
};

export const clickBannerCarouselEvent = (clickEvent: AnalyticsContextValue["clickEvent"], bannerId: string): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS, // category refers to screen name
        action: DO_CLICK_ACTIONS.BANNER, //action refers to object name
        label: LABELS.BANNER_CLICK, // label refers to object value
        context: JSON.stringify({
            value: bannerId,
            source: SOURCE,
        }),
    });
};

export const impressionBannerCarouselEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    bannerId: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS,
        action: DO_IMPRESSION_ACTIONS.BANNER_IMPRESSION,
        context: JSON.stringify({
            bannerId: bannerId,
            source: SOURCE,
        }),
    });
};

export const savingsTextImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { orderId, text }: { orderId: string; text: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT_SUCCESS, // category refers to screen name
        action: DO_IMPRESSION_ACTIONS.SAVINGS_IMPRESSION, //action refers to object name
        context: JSON.stringify({
            text: text,
            orderId: orderId,
            source: SOURCE,
        }),
    });
};

export interface PaymentCartClickEventParams {
    clickEvent: AnalyticsContextValue["clickEvent"];
    category: string;
    action: string;
    label: string;
    context: string;
}

export const paymentCartClickEvent = ({
    clickEvent,
    category,
    action,
    label,
    context,
}: PaymentCartClickEventParams): void => {
    clickEvent({
        category,
        action,
        label,
        context,
    });
};
